import React, {useState, useEffect, useCallback} from 'react'
import {Descriptions, Form, Input, Button, Modal} from 'antd'
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from "@/tool";

const {WizContainer, modelUtils} = framework_tool;
const {WizSpin, WizCard} = component_tool
const {Session} = utils_tool

import {AddForm} from "./components";

import './index.less'

class Index extends WizContainer {
  constructor(props) {
    super(props);
  }

  propsAndStateOnChange = {
    add: this._add.bind(this)
  }

  _add(nextProps, nextState) {
    let {success, msg, data} = nextProps.add
    if (success) {
      wizNotice.success(msg)
      this.jumpPage('replace', '/accountConsolidationRecord/detail', {id: data})
    } else {
      wizNotice.error(msg || '系统运行繁忙,请稍后再试')
      return false;
    }
    return true
  }

  _onSubmit = (data) => {
    console.log('data', data)
    const personIdOld = data?.personIdOld?.map(item => item?.personId).filter(item => !!item)
    const personIdNew = data?.personIdNew?.map(item => item?.personId).filter(item => !!item)
    if (!personIdOld || personIdOld.length > 1 || !personIdNew || personIdNew.length > 1) {
      wizNotice.warn('请确认参数是否正确');
      return;
    } else if (personIdOld[0] === personIdNew[0]) {
      wizNotice.warn('新旧两个账号不能一致');
      return;
    }

    Modal.confirm({
      title: '合并确认',
      content: `确认将${data?.personIdOld?.[0].userName}和${data?.personIdNew?.[0].userName}的业务进行数据合并？`,
      onOk: () => {
        this.doAction({
          path: 'accountConsolidationRecord/add',
          payload: {
            key: 'accountConsolidationRecord@add',
            apiParams: {
              personIdOld: personIdOld[0],
              personIdNew: personIdNew[0],
            }
          }
        })
      }
    })



  }

  _render() {
    return (
      <div className={'accountConsolidationRecord-add'}>
        <WizCard title={'合并账号'}>
          <AddForm submit={this._onSubmit}/>
        </WizCard>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {accountConsolidationRecord} = state;

  const add = modelUtils.getModelEntity(accountConsolidationRecord, 'accountConsolidationRecord@add');

  const load = modelUtils.getLoadingState(state, ['accountConsolidationRecord']);

  return {
    add,
    ...load,
  }
};

export default connect(mapStateToProps)(Index);
